// extracted by mini-css-extract-plugin
export default {"root":"_3ahSk","static-add-widget":"Yz2B4","staticAddWidget":"Yz2B4"};